import { ANIMAL_DIED, ANIMAL_DISCARDED, ANIMAL_PREGNANT } from './constants'

/**
 * Quais matrizes de um lote entram no manejo de DG.
 *
 * A regra vive aqui porque duas camadas precisam concordar: a tela de DG, que decide o que o
 * veterinário preenche, e o Resumo DG, que conta o que foi preenchido. Quando as duas divergem, o
 * "Concluídas X/Y" nunca fecha e o denominador da taxa de prenhez fica errado.
 *
 * O predicado aceita tanto o DTO (`utils.getWithParam`, que devolve `omit_from_dg_final`) quanto o
 * model do WatermelonDB (query direta na collection, que expõe `omitFromDGFinal`). Ler o nome
 * errado devolve `undefined` em silêncio — foi assim que quatro campos do Resumo passaram meses
 * lendo nada.
 */

const DN_DIED_BRACKETED = `[${ANIMAL_DIED}] ${ANIMAL_DIED}`

const isOmittedFromDGFinal = (cow) =>
  Boolean(
    cow.omit_from_dg_final ??
    cow.omitFromDGFinal ??
    cow._raw?.omit_from_dg_final,
  )

/**
 * @param cow          registro D0 (DTO ou model)
 * @param iatf         a IATF da matriz considerada para elegibilidade
 * @param dn           o DN da matriz considerado para elegibilidade
 */
export const isInDGRoster = (cow, { iatf, dn } = {}) => {
  if (!cow) return false
  if (isOmittedFromDGFinal(cow)) return false
  if (
    cow.observacaoD0 === ANIMAL_DIED ||
    cow.observacaoD0 === ANIMAL_PREGNANT
  ) {
    return false
  }
  if (
    iatf?.observacao === ANIMAL_DISCARDED ||
    iatf?.observacao === ANIMAL_DIED
  ) {
    return false
  }
  if (dn?.observacao === ANIMAL_DIED || dn?.observacao === DN_DIED_BRACKETED) {
    return false
  }
  return true
}
